import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Icon from "../icons/Icons";
import { openCalendly } from "../../lib/calendly";
import "./Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("menu-open", open);
    return () => document.body.classList.remove("menu-open");
  }, [open]);

  return (
    <header id="site-header" className={scrolled ? "scrolled" : ""}>
      <div className="header-inner container">
        <Link to="/" className="wordmark" aria-label="TysonWorks home">
          <span className="wordmark-tyson">Tyson</span>
          <span className="wordmark-works">Works</span>
          <span className="wordmark-cursor" />
        </Link>

        <nav className={`site-nav ${open ? "open" : ""}`} aria-label="Main">
          <ul>
            <li>
              <NavLink to="/about">About</NavLink>
            </li>
            <li>
              <NavLink to="/services">Services</NavLink>
            </li>
            <li>
              <NavLink to="/products">Products</NavLink>
            </li>
            <li>
              <a
                href="https://medium.com/tysonworks"
                target="_blank"
                rel="noopener noreferrer"
              >
                Blog <Icon name="arrowUpRight" size={13} strokeWidth={2} />
              </a>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
          <button className="btn btn-primary nav-cta" onClick={openCalendly}>
            <Icon name="calendar" size={16} />
            Book intro call
          </button>
        </nav>

        <button
          className="menu-toggle"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(!open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
